import { useEffect, useRef } from 'react';

export const usePreventMultiClick = (fn) => {
  const isProcessing = useRef(false);
  const timerId = useRef(null);

  const preventMultiClick = async (...args) => {
    if (isProcessing?.current) return;
    isProcessing.current = true;
    timerId.current = setTimeout(() => {
      isProcessing.current = false;
    }, 3000);
    return await fn(...args);
  };

  useEffect(() => {
    return () => {
      if (timerId?.current) {
        clearTimeout(timerId.current);
      }
    };
  }, []);

  const stopProcessing = () => {
    if (timerId?.current) {
      clearTimeout(timerId.current);
    }
    isProcessing.current = false;
  }

  return { preventMultiClick, isProcessing: isProcessing.current, stopProcessing };
}